
import PropTypes from 'prop-types'

const BodyContent = ({ children, variant, ...rest }) => {

  return (
    <div
      style={{
        maxWidth: '1200px',
        margin: variant === 'center' ? '0 auto' : ''
      }}
      {...rest}>
      {children}
    </div>
  )
}

BodyContent.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['default', 'center'])
}

export default BodyContent
